import { steamEndpointIds } from 'root/src/shared/steam/steam.constants';
import cronJobPayloadSchema from 'root/src/shared/descriptions/endpoints/schemas/requestSchemas/cronJobPayloadSchema';
export const initSteamReviewsReportEndpoint = {
    [steamEndpointIds.INIT_STEAM_REVIEWS_REPORT]: {
        payloadSchema: cronJobPayloadSchema,
        isCron: true,
    },
};
